module.exports = __webpack_public_path__ + "static/media/logo.200fb510.svg";